import $ from 'jquery'

import * as Model from 'api/model'

export default function PoziStyle () {
  // Adapters
  const adapters = {
    apply: function () {
      return apply()
    }
  }

  var apply = function () {
    const buttonColor = Model.get('config.settings.color', 'green')
    $('.mdl-button--colored').css('background', buttonColor)
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
